(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('CollectionIbqDetailController', CollectionIbqDetailController);

    CollectionIbqDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Collection', 'Disc'];

    function CollectionIbqDetailController($scope, $rootScope, $stateParams, previousState, entity, Collection, Disc) {
        var vm = this;

        vm.collection = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('virtuallibraryApp:collectionUpdate', function(event, result) {
            vm.collection = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
